import React from 'react'
import { validateQttSeats } from '@helpers'
import FileSaver from 'file-saver'
import {
	SAME_AMOUNT,
	NO_SEAT,
	MISSING,
	MAX_TO_VALIDADE,
	ERROR_MSG_CALCULATED_VALUES,
} from '@constants'
import Bus from '../bus.component'
import Button from '../../../../components/buttons/buttons.component.jsx'
import TicketSaleService from '../../../../services/ticket-sale.service'
import DenialService from '../../../../services/denial.service'
import { CalculationsService } from '../../../../services'
import TicketSaleSelectors from '../../../../ducks/ticket-sale/ticket-sale.selectors'
import busSeatSelectionHelper from '../../../../helpers/bus-seat-selection.helper'
import TripDiscountHelper from '../../../../helpers/trip-discount.helper'
import BusSeatSelectionSelectors from '../../../../selectors/bus-seat-selection.selectors'
import { BusSeatSelectionModalResume } from '../bus-seat-selection-modal-resume'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '@actions'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import ReactHtmlParser from 'react-html-parser'
import ModalConfirmation from '../../../../components/modal/modal-confirmation.component'
import insuranceBanner from '../../../../../assets/images/seguro/banner-intermunicipal.png'
import {
	StyledBannerContainer,
	StyledInsuranceModalContainer,
	newWindow,
	StyledBusContainer,
	StyledResumeContainer,
	StyledButtonContainer,
	StyledBusSeatLegend,
	StyledContent,
	StyledDenialModalContainer,
} from './bus-seat-selection.styles'
import { Creators as TicketSaleCreators } from '../../../../ducks/ticket-sale/ticket-sale'
import { history } from './../../../../helpers/history'

function getInsurancePointsForCurrentPriceOption(insuranceBRL, selectedPrice, conversionParameters) {
	if (!selectedPrice || !insuranceBRL || insuranceBRL <= 0) return 0
	// Pure PONTOS only: points > 0 AND value == 0
	if (!(selectedPrice.points > 0 && selectedPrice.value === 0)) return 0
	if (!conversionParameters || !conversionParameters.length) return 0

	const cp = conversionParameters.find(c =>
		c.conversionParameterId === selectedPrice.id ||
		(c.pointsPercentage === 100 && c.forSubscribers === selectedPrice.forSubscribers)
	)
	if (!cp) return 0

	return Math.ceil(
		(insuranceBRL * cp.valueFactor * cp.pointsPercentage) / cp.pointValue / 100
	)
}

class BusSeatSelectionComponent extends React.Component {
	constructor(props) {
		super(props)
		this.onResult = onResult.bind(this)
		this.onResultDenialsModal = onResultDenialsModal.bind(this)
		this.onDeselect = onDeselect.bind(this)
		this.selectBusSeat = selectBusSeat.bind(this)
		this.getSelectParams = getSelectParams.bind(this)
		this.getDeselectParams = getDeselectParams.bind(this)
		this.validateAndSelect = validateAndSelect.bind(this)
		this.incrementSeatsQtt = incrementSeatsQtt.bind(this)
		this.decrementSeatsQtt = decrementSeatsQtt.bind(this)
		this.resetSeatsQtt = resetSeatsQtt.bind(this)
		this.getCalculatedValues = getCalculatedValues.bind(this)
		this.getBusSeatReservation = getBusSeatReservation.bind(this)
		this.continuar = continuar.bind(this)
		this.checkInsurance = checkInsurance.bind(this)
		this.state = {
			currentNumber: 0,
			isModalConfirmationOpen: false,
			withInsuranceGoing: false,
			withInsuranceGoingSetted: false,
			withInsuranceReturn: false,
			withInsuranceReturnSetted: false,
			insuranceValue: 0,
			insurancePoints: 0,
			seatsQtt: 0,
			isModalDenialsOpen: false,
			denialsList: [],
			benefitCategory: null,
			isCheckedPointsModalOpen: false,
		}
		this._isMounted = false
	}

	setCheckedPointsModalOpen = (confirmed) => {
		this.setState({
			isCheckedPointsModalOpen: !this.state.isCheckedPointsModalOpen,
		})

		if (confirmed) history.push('compra-de-pontos')
	}

	downloadDenials = async () => {
		const { hideLoading, showLoading, toastError } = this.props
		showLoading()
		try {
			await Promise.all(
				this.state.denialsList.map((denial) => {
					return DenialService.getDenialById(denial.id)
						.then((data) => {
							if (data) FileSaver.saveAs(data, `RECUSA-${denial.id}.png`)
						})
						.catch((error) => {
							toastError({ message: 'Falha ao baixar a recusa.' })
						})
				})
			)
		} catch (e) {
			toastError({ message: 'Falha ao baixar a recusa.' })
			hideLoading()
		} finally {
			hideLoading()
		}
	}

	componentWillUnmount() {
		this._isMounted = false
	}

	render() {
		const {
			busSeats,
			onCancel,
			isBusSelectionGoingStep,
			isBusSelectionReturnStep,
			onlyMoneyOnPriceOption,
			conexao,
			familyDiscountParameters,
			familyDiscountAllowed,
			isRebooking,
			user,
		} = this.props

		if (familyDiscountParameters && familyDiscountParameters.isActive) {
			const isAllowedBusCompany =
				TripDiscountHelper.checkAllowedBusCompanies(
					familyDiscountParameters,
					this.props.ticketSale.busCompany
				)

			const { tripGoing, tripReturn } = this.props

			const isInvalidRouteGoing = TripDiscountHelper.checkInvalidRoutes(
				tripGoing.origem,
				tripGoing.destino
			)

			let isInvalidRouteReturn = false

			if (tripReturn) {
				isInvalidRouteReturn = TripDiscountHelper.checkInvalidRoutes(
					tripReturn.origem,
					tripReturn.destino
				)
			}

			const isValidTrip = !isInvalidRouteGoing && !isInvalidRouteReturn

			const isPublicBody = user && user.hasPublicBody
			const isRequester = user && user.isRequester

			if (
				onlyMoneyOnPriceOption &&
				isAllowedBusCompany &&
				isValidTrip &&
				!isPublicBody &&
				!familyDiscountAllowed &&
				!isRequester
			) {
				this.props.setFamilyDiscountAllowed(true)
			}
		}

		const highestBusSeatNumber = Math.max.apply(
			null,
			busSeats.map(({ number }) => number)
		)

		const { origin, destination } = this.props.ticketSale

		let trechoAtual = {
			origem: `${origin.city}/${origin.state}`,
			destino: `${destination.city}/${destination.state}`,
		}

		const ehConexaoIda =
			isBusSelectionGoingStep && conexao != null && conexao.ehConexaoIda

		const ehConexaoVolta =
			isBusSelectionReturnStep && conexao != null && conexao.ehConexaoVolta

		if (ehConexaoIda)
			trechoAtual = conexao.conexaoIda.trecho[conexao.ordemViagemIda - 1]

		if (ehConexaoVolta)
			trechoAtual = conexao.conexaoVolta.trecho[conexao.ordemViagemVolta - 1]

		return (
			<React.Fragment>
				<span className="title-color f-xx-large">Seleção de poltrona</span>

				<StyledContent>
					<StyledBusContainer>
						<StyledBusSeatLegend>
							<div className="legend">
								<div className="free-seat" />
								<span>Livre</span>
							</div>
							<div className="legend">
								<div className="selected-seat" />
								<span>Selecionado</span>
							</div>
							<div className="legend">
								<div className="promotional-seat" />
								<span>Promocional</span>
							</div>
						</StyledBusSeatLegend>
						<Bus
							busSeats={busSeats}
							onDeselect={this.onDeselect}
							totalSeats={highestBusSeatNumber}
							onSelect={this.checkInsurance}
						/>
					</StyledBusContainer>
					<StyledResumeContainer>
						{ehConexaoIda || ehConexaoVolta ? (
							<span className="blue f-xx-small">
								{trechoAtual.origem} {' > '} {trechoAtual.destino}
							</span>
						) : null}

						<br></br>
						<BusSeatSelectionModalResume
							calculatedValues={this.props.calculatedValues}
						/>
						<p>
							<br />
							Tarifa com desconto somente para poltronas promocionais de
							acordo com disponibilidade.
							<br />
							<br />
							Viajando em mais pessoas?
							<br />
							Apenas clique em outro assento para adicioná-lo.
							<br />
							{familyDiscountAllowed &&
								onlyMoneyOnPriceOption &&
								!isRebooking ? (
								<span>
									<br />
									{ReactHtmlParser(familyDiscountParameters.message)}
									<br />
									<span style={{ fontSize: '14px' }}>
										*Promoção não cumulativa com poltronas
										promocionais e cupons de desconto
									</span>
								</span>
							) : null}
						</p>

						<StyledButtonContainer>
							<Button secondary type="button" onClick={onCancel}>
								Cancelar
							</Button>
							<Button
								primary
								type="button"
								onClick={this.continuar}
								className="continue-button">
								Continuar
							</Button>
						</StyledButtonContainer>
						<ModalConfirmation
							onResult={this.onResult}
							title=""
							buttonYesText="Continuar com seguro"
							buttonNoText="Continuar sem seguro"
							isOpen={this.state.isModalConfirmationOpen}>
							<StyledBannerContainer>
								<img
									className="insurance-image"
									src={insuranceBanner}
								/>
							</StyledBannerContainer>
							<StyledInsuranceModalContainer>
								<div data-testid="insurance-modal-value">
									{this.state.insurancePoints > 0
										? `${this.state.insurancePoints.toLocaleString('pt-BR')} pts/passageiro`
										: `${this.state.insuranceValue.$toReais()}/passageiro`}
								</div>
								<div>Por trecho</div>
								<span
									className="details"
									onClick={() =>
										newWindow(
											'/intermunicipal/seguro',
											'Seguro intermunicipal',
											500,
											600,
											''
										)
									}>
									Ver cobertura do seguro
								</span>
							</StyledInsuranceModalContainer>
						</ModalConfirmation>
						<ModalConfirmation
							onResult={this.onResultDenialsModal}
							title=""
							buttonYesText="Sim"
							buttonNoText="Não"
							isOpen={this.state.isModalDenialsOpen}>
							<StyledDenialModalContainer>
								<div>
									<h1>Problemas em reserva de gratuidade</h1>
									<p>
										Não foi possível a reserva da sua gratuidade,
										provavelmente todas as cotas de gratuidades já
										estão ocupadas.
									</p>
									<div>
										<span>Motivos da recusa:</span>
										<ul>
											{this.state.denialsList.map((denial) => (
												<li>
													<span>{denial.benefitType}</span>
													<span> - </span>
													<span>{denial.reason}</span>
												</li>
											))}
										</ul>
									</div>
									<p>
										Você deseja prosseguir com a reserva da poltrona
										com passagem {this.state.benefitCategory}?
									</p>
								</div>
								<span
									style={{
										position: 'absolute',
										fontSize: '20px',
										bottom: '30px',
										textDecoration: 'underline',
										cursor: 'pointer',
										backgroundColor: 'transparent',
										color: '#1e70bf',
									}}
									onClick={this.downloadDenials}
									role="button">
									Salvar recusa(s)
								</span>
							</StyledDenialModalContainer>
						</ModalConfirmation>
					</StyledResumeContainer>
				</StyledContent>
				<ModalConfirmation
					buttonNoText="Agora não"
					title="Compra de passagem"
					onResult={this.setCheckedPointsModalOpen}
					buttonYesText="Comprar pontos"
					isOpen={this.state.isCheckedPointsModalOpen}>
					Você não possui pontos suficientes para comprar esta passagem.
					Deseja comprar pontos?
				</ModalConfirmation>
			</React.Fragment>
		)
	}
}

async function getCalculatedValues(tripDatas) {
	this.props.setIsCalculatingValues(true)

	try {
		const { success, data } = await CalculationsService.getCalculatedValues(
			tripDatas
		)

		if (success) {
			const ticketsGoing = data.ticketsGoing.map((ticket, idx) => ({
				...ticket,
				...tripDatas.ticketsGoing[idx],
			}))

			const ticketsReturn = data.ticketsReturn.map((ticket, idx) => ({
				...ticket,
				...tripDatas.ticketsReturn[idx],
			}))

			const values = {
				...tripDatas,
				...data,
				ticketsGoing,
				ticketsReturn,
			}

			this.props.setCalculatedValues(values)

			this.props.setIsCalculatingValues(false)

			return
		}

		this.props.toastWarning({
			message: ERROR_MSG_CALCULATED_VALUES,
		})
	} catch (error) {
		this.props.setIsCalculatingValues(false)

		toastError({ message: ERROR_MSG_CALCULATED_VALUES })
	}
}

async function onDeselect(busSeat) {
	const { onDeselect, hideLoading, showLoading, conexao, toastError } =
		this.props

	showLoading()

	try {
		const deselectParams = this.getDeselectParams(busSeat)
		const { success } = await TicketSaleService.cancelBusSeatBooking(
			deselectParams
		)

		if (success) {
			this.decrementSeatsQtt()
			onDeselect({ busSeat, conexao })

			this.getCalculatedValues({
				selectedPriceGoingId: this.props.tripPriceGoing.id,
				selectedPriceReturnId: this.props.tripPriceReturn.id,
				ticketsGoing: this.props.selectedBusSeatsGoing,
				ticketsReturn: this.props.selectedBusSeatsReturn,
			})
		}
	} catch (e) {
		toastError({
			message: `Erro ao tentar cancelar reserva da poltrona ${busSeat}.`,
		})
	} finally {
		hideLoading()
	}
}

function onResult(confirm) {
	const { isBusSelectionGoingStep } = this.props
	const { currentNumber, discount } = this.state

	const withInsurance = confirm

	if (isBusSelectionGoingStep) {
		this.setState(
			{
				...this.state,
				isModalConfirmationOpen: false,
				withInsuranceGoing: withInsurance,
				withInsuranceGoingSetted: true,
			},
			() => this.validateAndSelect(currentNumber, discount)
		)
	}

	if (!isBusSelectionGoingStep) {
		this.setState(
			{
				...this.state,
				isModalConfirmationOpen: false,
				withInsuranceReturn: withInsurance,
				withInsuranceReturnSetted: true,
			},
			() => this.validateAndSelect(currentNumber, discount)
		)
	}
}

function onResultDenialsModal(proceed) {
	this.setState({
		isModalDenialsOpen: false,
	})

	if (!proceed) {
		this.props.onCancel()
	}
}

function getSelectParams(busSeat) {
	const {
		tripGoing,
		tripReturn,
		groupGoing,
		groupReturn,
		serviceGoing,
		serviceReturn,
		extraDataGoing,
		extraDataReturn,
		isBusSelectionGoingStep,
		conexao,
		ticketSale,
	} = this.props

	if (isBusSelectionGoingStep && !conexao.ehConexaoIda) {
		return {
			busSeat,
			busClass: tripGoing.busClass,
			originId: tripGoing.origemId,
			...extraDataGoing,
			group: groupGoing,
			destinationId: tripGoing.destinoId,
			service: serviceGoing,
			tripDate: tripGoing.departure,
			classCode: tripGoing.classCode,
			busCompany: tripGoing.enterprise,
			scheduleKey: tripGoing.scheduleKey,
			raceDate: tripGoing.raceDate,
			provider: tripGoing.provider,
			boardingTerminal: ticketSale.boardingTerminalGoing,
			disembarkingTerminal: ticketSale.disembarkingTerminalGoing,
		}
	} else if (!isBusSelectionGoingStep && !conexao.ehConexaoVolta) {
		return {
			busSeat,
			busClass: tripReturn.busClass,
			...extraDataReturn,
			group: groupReturn,
			service: serviceReturn,
			tripDate: tripReturn.departure,
			classCode: tripReturn.classCode,
			busCompany: tripReturn.enterprise,
			scheduleKey: tripReturn.scheduleKey,
			raceDate: tripReturn.raceDate,
			originId: tripReturn.origemId,
			destinationId: tripReturn.destinoId,
			provider: tripReturn.provider,
			boardingTerminal: ticketSale.boardingTerminalReturn,
			disembarkingTerminal: ticketSale.disembarkingTerminalReturn,
		}
	} else if (!isBusSelectionGoingStep && conexao.ehConexaoVolta) {
		let trecho = conexao.conexaoVolta.trecho[conexao.ordemViagemVolta - 1]
		return {
			busSeat,
			busClass: trecho.busClass,
			...extraDataReturn,
			group: trecho.group,
			service: trecho.service,
			tripDate: trecho.departure,
			classCode: trecho.classCode,
			busCompany: trecho.enterprise,
			scheduleKey: trecho.scheduleKey,
			raceDate: trecho.raceDate,
			originId: trecho.originId,
			destinationId: trecho.destinationId,
			provider: trecho.provider,
			boardingTerminal: ticketSale.boardingTerminalReturn,
			disembarkingTerminal: ticketSale.disembarkingTerminalReturn,
		}
	} else if (
		isBusSelectionGoingStep &&
		conexao != null &&
		conexao.ehConexaoIda
	) {
		let trecho = conexao.conexaoIda.trecho[conexao.ordemViagemIda - 1]
		return {
			busSeat,
			busClass: trecho.busClass,
			...extraDataGoing,
			group: trecho.group,
			service: trecho.service,
			tripDate: trecho.departure,
			classCode: trecho.classCode,
			busCompany: trecho.enterprise,
			scheduleKey: trecho.scheduleKey,
			raceDate: trecho.raceDate,
			originId: trecho.originId,
			destinationId: trecho.destinationId,
			provider: trecho.provider,
			boardingTerminal: ticketSale.boardingTerminalGoing,
			disembarkingTerminal: ticketSale.disembarkingTerminalGoing,
		}
	}
}

async function continuar() {
	const {
		showLoading,
		hideLoading,
		toastWarning,
		onContinue,
		selectedBusSeatsGoing,
		selectedBusSeatsReturn,
		stepOrderCurrent,
		isRebooking,
	} = this.props

	showLoading()

	if (this.state.seatsQtt == NO_SEAT) {
		hideLoading()
		toastWarning({
			message: 'Você precisa selecionar pelo menos uma poltrona',
		})
		return
	}

	const { status, msg } = validateQttSeats(
		selectedBusSeatsGoing,
		selectedBusSeatsReturn,
		stepOrderCurrent,
		isRebooking
	)

	if (status === MISSING) {
		hideLoading()
		toastWarning({ message: msg })
	} else {
		this.props.setStepOrderCurrent(this.props.stepOrderCurrent + 1)
		this.resetSeatsQtt()
		await onContinue()
		hideLoading()
	}
}

function getDeselectParams(busSeat) {
	return busSeatSelectionHelper.getDeselectParams(busSeat)
}

function incrementSeatsQtt() {
	this.setState({
		...this.state,
		seatsQtt: ++this.state.seatsQtt,
	})
}

function decrementSeatsQtt() {
	this.setState({
		...this.state,
		seatsQtt: --this.state.seatsQtt,
	})
}

function resetSeatsQtt() {
	this.setState({
		...this.state,
		seatsQtt: 0,
	})
}

async function getBusSeatReservation(seatData) {
	const { toastError } = this.props

	try {
		const { success, data } = await TicketSaleService.bookBusSeat(seatData)

		if (data.hasDenials) {
			this.setState({
				isModalDenialsOpen: true,
				denialsList: data.denialsList,
				benefitCategory: data.benefitCategory,
			})
		}

		if (!success) {
			throw new Error()
		}

		return data
	} catch (e) {
		toastError({
			message:
				'Não foi possível reservar poltrona, tente novamente ou escolha outra poltrona.',
		})
	}
}

function checkInsurance(number, discount) {
	const {
		selectedBusSeatsGoing,
		selectedBusSeatsReturn,
		isBusSelectionGoingStep,
		hideLoading,
		user,
	} = this.props

	const { insurance } = this.getSelectParams(number)
	const { selectedPriceGoing, selectedPriceReturn, tripPrice } = this.props
	const selectedPrice = isBusSelectionGoingStep ? selectedPriceGoing : selectedPriceReturn
	const insurancePoints = getInsurancePointsForCurrentPriceOption(
		insurance,
		selectedPrice,
		tripPrice && tripPrice.conversionParameters
	)
	const { ehConexaoIda, ehConexaoVolta } = this.props.conexao
	const isConection = ehConexaoIda || ehConexaoVolta

	let isPublicBody = false

	if (user) {
		isPublicBody = user.hasPublicBody
	}

	this.setState({
		insuranceValue: insurance,
		insurancePoints,
		currentNumber: number,
		discount,
	})

	if (!isPublicBody && !isConection && insurance > 0) {
		const isGoingStep =
			selectedBusSeatsGoing.length === 0 &&
			isBusSelectionGoingStep &&
			!this.state.withInsuranceGoingSetted

		const isReturnStep =
			selectedBusSeatsReturn.length === 0 &&
			!isBusSelectionGoingStep &&
			!this.state.withInsuranceReturnSetted

		if (isGoingStep || isReturnStep) {
			this.setState({ isModalConfirmationOpen: true })
			hideLoading()
			return
		}
	}

	this.validateAndSelect(number, discount)
}

async function validateAndSelect(number, discount) {
	const {
		selectedBusSeatsGoing,
		selectedBusSeatsReturn,
		isBusSelectionGoingStep,
		isBusSelectionReturnStep,
		isInsuranceRequired,
		toastWarning,
		hideLoading,
		showLoading,
		user,
		calculatedValues,
		client,
		admin,
		tripPriceGoing,
		tripPriceReturn,
	} = this.props

	if (this.state.seatsQtt == MAX_TO_VALIDADE) {
		toastWarning({
			message: `Você não pode selecionar mais do que ${MAX_TO_VALIDADE} poltronas.`,
		})
		return
	}

	let totalPoints = 0

	if (isBusSelectionGoingStep) {
		const { pointsToShow } = tripPriceGoing
		totalPoints = pointsToShow + calculatedValues.totalPointsUsed
	} else {
		const { pointsToShow } = tripPriceReturn
		totalPoints = pointsToShow + calculatedValues.totalPointsUsed
	}

	const userPoints = client.balancePoints || admin.moveflexPoints

	if (totalPoints > userPoints) {
		this.setCheckedPointsModalOpen()
		return
	}

	showLoading()

	const { status, msg } = validateQttSeats(
		selectedBusSeatsGoing,
		selectedBusSeatsReturn,
		this.props.stepOrderCurrent,
		this.props.isRebooking
	)

	if (status === SAME_AMOUNT) {
		toastWarning({ message: msg })
		hideLoading()
		return
	}

	let seatData = this.getSelectParams(number)

	let withInsurance = false

	if (isBusSelectionGoingStep) {
		withInsurance = this.state.withInsuranceGoing
	} else {
		withInsurance = this.state.withInsuranceReturn
	}

	let isPublicBody = false

	if (user) {
		isPublicBody = user.hasPublicBody
	}

	seatData.withInsurance = isPublicBody ? isInsuranceRequired : withInsurance

	let isSeatCaregiver = false

	if (user) {
		const isEligibleForBenefit = user.isEligibleForBenefit
		seatData.isEligibleForFreeBenefits = isEligibleForBenefit

		const { benefitDataModel } = user
		const hasCaregiver = !!benefitDataModel && !!benefitDataModel.caregiverCpf

		let isCargiverSeatGoing = false
		let isCaregiverSeatReturning = false
		let gotCaregiverSeatsLimit = false
		let selectedBusSeatsGoingQtt = selectedBusSeatsGoing.length

		if (hasCaregiver) {
			isCargiverSeatGoing =
				isBusSelectionGoingStep && selectedBusSeatsGoingQtt == 1

			isCaregiverSeatReturning =
				isBusSelectionReturnStep && selectedBusSeatsReturn.length == 1

			gotCaregiverSeatsLimit =
				isBusSelectionGoingStep && selectedBusSeatsGoingQtt > 1
		} else {
			gotCaregiverSeatsLimit =
				isEligibleForBenefit &&
				isBusSelectionGoingStep &&
				!!selectedBusSeatsGoingQtt
		}

		if (gotCaregiverSeatsLimit) {
			this.props.toastError({
				message: 'Você não pode selecionar mais poltronas.',
			})

			hideLoading()

			return
		}

		isSeatCaregiver = isCargiverSeatGoing || isCaregiverSeatReturning
	}

	let data = await this.getBusSeatReservation({
		isCaregiver: isSeatCaregiver,
		...seatData,
	})

	hideLoading()

	if (data) {
		this.selectBusSeat({ ...data, ...seatData, number, discount })
	}
}

function selectBusSeat(seat) {
	const { onSelect, conexao } = this.props

	this.incrementSeatsQtt()

	let selectedBusSeatsGoing = this.props.selectedBusSeatsGoing
	let selectedBusSeatsReturn = this.props.selectedBusSeatsReturn

	if (conexao.ehConexaoIda) {
		seat.conexao = conexao.conexaoIda.trecho[conexao.ordemViagemIda - 1]
	}

	if (conexao.ehConexaoVolta) {
		seat.conexao = conexao.conexaoVolta.trecho[conexao.ordemViagemVolta - 1]
	}

	let newSeat = {
		...seat,
		...seat.price,
		poltrona: seat.number,
		discountForPromotionBusSeat: seat.discount,
	}

	if (seat.conexao) {
		newSeat = {
			...newSeat,
			...seat.conexao,
			destinationCity: seat.conexao.destination,
			originCity: seat.conexao.origin,
		}
	} else {
		const { origin, originGoing, destinationGoing, destination } =
			this.props.ticketSale

		newSeat = {
			...newSeat,
			originCity: originGoing,
			originState: origin.state,
			destinationCity: destinationGoing,
			destinationState: destination.state,
		}
	}

	if (!this.props.isBusSelectionReturnStep) {
		selectedBusSeatsGoing = [...selectedBusSeatsGoing, newSeat]
	} else {
		selectedBusSeatsReturn = [
			...selectedBusSeatsReturn,
			{
				...newSeat,
				originCity: newSeat.destinationCity,
				originState: newSeat.destinationState,
				destinationCity: newSeat.originCity,
				destinationState: newSeat.originState,
			},
		]
	}

	this.getCalculatedValues({
		selectedPriceGoingId: this.props.tripPriceGoing.id,
		selectedPriceReturnId: this.props.tripPriceReturn.id,
		ticketsGoing: selectedBusSeatsGoing,
		ticketsReturn: selectedBusSeatsReturn,
		paymentType: 'Nenhum',
		installments: 0,
		couponDiscountPercent: 0,
		muviflexNumber: 0,
		ehPrimeiraCompraMuvicard: false,
	})

	onSelect(newSeat)
}

const mapStateToProps = (store) => ({
	user: store.user,
	groupGoing: store.ticketSale.groupGoing,
	groupReturn: store.ticketSale.groupReturn,
	serviceGoing: store.ticketSale.serviceGoing,
	serviceReturn: store.ticketSale.serviceReturn,
	extraDataGoing: store.ticketSale.extraDataGoing,
	extraDataReturn: store.ticketSale.extraDataReturn,
	busSeatsGoing: store.busSeatSelection.busSeatsGoing,
	originId: store.ticketSale.originId,
	ticketSale: store.ticketSale,
	destinationId: store.ticketSale.destinationId,
	onlyMoneyOnPriceOption: store.ticketSale.onlyMoneyOnPriceOption,
	stepOrderCurrent: store.ticketSale.stepOrderCurrent,
	isRebooking: store.ticketSale.rebookingData.isRebooking,
	conexao: store.conexao,
	tripGoing: TicketSaleSelectors.getTripGoing(store),
	tripReturn: TicketSaleSelectors.getTripReturn(store),
	isBusSelectionGoingStep: TicketSaleSelectors.isBusSelectionGoingStep(store),
	isBusSelectionReturnStep:
		TicketSaleSelectors.isBusSelectionReturnStep(store),
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedViagemIdaBusSeatsGoing:
		BusSeatSelectionSelectors.getSelectedViagemIda(store.busSeatSelection),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	poltronasIda: store.busSeatSelection.poltronasIda,
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
	numberOfPassengers: BusSeatSelectionSelectors.getNumberOfPassengers(
		store.busSeatSelection
	),
	tripPriceGoing: TicketSaleSelectors.getTripPriceGoing(store),
	tripPriceReturn: TicketSaleSelectors.getTripPriceReturn(store),
	selectedPriceGoing: store.ticketSale.selectedPriceGoing,
	selectedPriceReturn: store.ticketSale.selectedPriceReturn,
	tripPrice: store.tripPrice,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
	familyDiscountParameters:
		TicketSaleSelectors.getFamilyDiscountParameters(store),
	familyDiscountAllowed: store.ticketSale.familyDiscountAllowed,
	client: store.client,
	admin: store.admin,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastWarning: toastActions.warning,
			toastError: toastActions.danger,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			setStepOrderCurrent: TicketSaleCreators.setStepOrderCurrent,
			setCalculatedValues: TicketSaleCreators.setCalculatedValues,
			setFamilyDiscountAllowed: TicketSaleCreators.setFamilyDiscountAllowed,
			setIsCalculatingValues: TicketSaleCreators.setIsCalculatingValues,
		},
		dispatch
	)

const BusSeatSelection = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(BusSeatSelectionComponent)
)

export default BusSeatSelection
